import { SearchContext, VolumeOffIcon, VolumeOnIcon } from '@giphy/react-components'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { MARGIN } from '../constants'
import { AppContext } from '../context'
import { closeButton, logo } from '../img/images'
import { TRENDING } from './categories'

const buttonHighlightHeight = 3

const Container = styled.div`
    margin: 0 10px 10px 10px;
    display: flex;
    align-content: center;
    font-size: 18px;
`
const LogoContainer = styled.div`
    flex: 1;
    margin-top: ${MARGIN + buttonHighlightHeight}px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    img {
        cursor: pointer;
    }
`
const Logo = styled.img`
    height: 20px;
`
const Guys = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const VolumeContainer = styled.div<{ show: boolean }>`
    transform: translateX(${(props) => (props.show ? 0 : 10)}px);
    opacity: ${(props) => (props.show ? 1 : 0)};
    transition: transform 200ms ease-in-out, opacity 100ms ease-in-out;
    cursor: pointer;
    margin-right: 8px;
`
const volumeSize = 20
const GlobalVolume = () => {
    const { searchMode, videoMuted, setVideoMuted } = useContext(AppContext)
    return (
        <VolumeContainer show={searchMode === 'videos'}>
            {videoMuted ? (
                <VolumeOffIcon size={volumeSize} onClick={() => setVideoMuted(false)} />
            ) : (
                <VolumeOnIcon size={volumeSize} onClick={() => setVideoMuted(true)} />
            )}
        </VolumeContainer>
    )
}

const closeHeight = volumeSize - 6
const Header = () => {
    const { setDisplayGif, setSearchMode, onCloseClick } = useContext(AppContext)
    const { setSearch, setActiveChannel } = useContext(SearchContext)
    const goHome = () => {
        setDisplayGif(undefined)
        setSearch(TRENDING)
        setActiveChannel(undefined)
        setSearchMode('gifs')
    }
    return (
        <Container>
            <LogoContainer>
                <Logo src={logo} onClick={goHome} />
                <Guys>
                    <GlobalVolume />
                    {onCloseClick && <img src={closeButton} height={closeHeight} onClick={onCloseClick} />}
                </Guys>
            </LogoContainer>
        </Container>
    )
}

export default Header
